var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7503 11.75C19.7503 12.7165 18.9668 13.5 18.0003 13.5C17.0338 13.5 16.2503 12.7165 16.2503 11.75C16.2503 10.7835 17.0338 9.99997 18.0003 9.99997C18.9668 9.99997 19.7503 10.7835 19.7503 11.75Z",
    fill: "url(#paint0_linear_702_18755)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 16.5625C18.7252 16.5625 19.3128 17.1501 19.3128 17.875V26.625C19.3128 27.3498 18.7252 27.9375 18.0003 27.9375C17.2754 27.9375 16.6878 27.3498 16.6878 26.625V17.875C16.6878 17.1501 17.2754 16.5625 18.0003 16.5625Z",
    fill: "url(#paint1_linear_702_18755)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9734 2.98708C20.0624 0.191163 15.9381 0.191152 14.0271 2.98707L13.2712 4.09298C8.53567 11.0216 4.46699 18.3832 1.11971 26.0791L0.961839 26.4421C-0.217757 29.1542 1.56438 32.2337 4.50358 32.5622C13.4734 33.5647 22.5271 33.5647 31.4969 32.5622C34.4361 32.2337 36.2183 29.1542 35.0387 26.4421L34.8808 26.0791C31.5335 18.3832 27.4648 11.0216 22.7293 4.09298L21.9734 2.98708ZM16.1943 4.46829C17.0629 3.19742 18.9376 3.19742 19.8062 4.46829L20.5621 5.5742C25.2041 12.366 29.1925 19.5822 32.4736 27.1261L32.6315 27.4891C33.1065 28.5811 32.3889 29.8212 31.2054 29.9534C22.4293 30.9343 13.5712 30.9343 4.79515 29.9534C3.61163 29.8212 2.89403 28.5811 3.36901 27.4891L3.52688 27.1261C6.80805 19.5822 10.7964 12.366 15.4384 5.57419L16.1943 4.46829Z",
    fill: "url(#paint2_linear_702_18755)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_18755",
    x1: 26.4457,
    y1: 3.63947,
    x2: 8.51812,
    y2: 30.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF49A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_18755",
    x1: 26.4457,
    y1: 3.63947,
    x2: 8.51812,
    y2: 30.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF49A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_702_18755",
    x1: 26.4457,
    y1: 3.63947,
    x2: 8.51812,
    y2: 30.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF655B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF49A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.98207703afaeb36245d6c8070a6130f8.svg";
export { ForwardRef as ReactComponent };